import { render } from "./LinChuangView.vue?vue&type=template&id=37f962da&scoped=true&ts=true"
import script from "./LinChuangView.vue?vue&type=script&lang=ts"
export * from "./LinChuangView.vue?vue&type=script&lang=ts"

import "./LinChuangView.vue?vue&type=style&index=0&id=37f962da&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f962da"]])

export default __exports__